// English dictionary. The Meta app review requires the Facebook and Instagram
// screens in English, so every key used by those screens must exist here.
const en = {
  // ─── Navigation (dashboard sidebar) ───
  'nav.menu': 'Main Menu',
  'nav.dashboard': 'Dashboard',
  'nav.whatsapp': 'WhatsApp',
  'nav.templates': 'Templates',
  'nav.history': 'History',
  'nav.users': 'Users',
  'nav.connections': 'Connections',
  'nav.meta': 'Meta',
  'nav.inbox': 'Inbox',
  'nav.settings': 'Settings',
  'nav.dataDeletion': 'Data Deletion',
  'nav.logout': 'Log out',

  // ─── Login ───
  'login.welcome': 'Welcome back',
  'login.subtitle': 'Sign in with your credentials to access the dashboard.',
  'login.email': 'Email',
  'login.emailPlaceholder': 'you@email.com',
  'login.password': 'Password',
  'login.submit': 'Sign in',
  'login.submitting': 'Signing in...',
  'login.brandTitle': 'Manage your Conversations',
  'login.brandSubtitle': 'Send templates, organize leads and follow your conversations in one place.',

  // ─── Common ───
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.close': 'Close',
  'common.send': 'Send',
  'common.search': 'Search',
  'common.loading': 'Loading...',
  'common.confirm': 'Confirm',
  'common.back': 'Back',
  'common.language': 'Language',

  // ─── Meta screens (Facebook / Instagram) ───
  'meta.title': 'Meta API Connections',
  'meta.newConnection': 'New Meta Connection',
  'meta.none': 'No Meta connection configured',
  'meta.connectionName': 'Connection Name',
  'meta.connectionNamePlaceholder': 'My Instagram Business',
  'meta.platform': 'Platform',
  'meta.platformWhatsapp': 'WhatsApp Business',
  'meta.platformInstagram': 'Instagram',
  'meta.platformFacebook': 'Facebook Messenger',
  'meta.appId': 'App ID',
  'meta.appIdRequired': 'App ID *',
  'meta.appIdHint': 'App ID from Facebook Developers',
  'meta.appSecretRequired': 'App Secret *',
  'meta.appSecretHint': 'App Secret from Facebook Developers',
  'meta.pageId': 'Page ID',
  'meta.instagramId': 'Instagram ID',
  'meta.verifyToken': 'Verify Token (for Webhook)',
  'meta.verifyTokenHint': 'Use this token when setting up the webhook in Facebook Developers',
  'meta.connecting': 'Connecting...',
  'meta.comments': 'Comments on posts',
  'meta.conversations': 'Conversations (Inbox)',
  'meta.sendDirectTest': 'Send a Direct message (test)',
  'meta.messagePlaceholder': 'Write your message...',
  'meta.replyPlaceholder': 'Reply...',
  'meta.replyCommentPlaceholder': 'Reply to this comment...',
  'meta.noComments': 'No comments loaded. Click "Load comments".',
  'meta.noConversations': 'No conversations loaded. Click "Load conversations".',
  'meta.noLogs': 'No logs available.',
  'meta.clear': 'Clear',

  // ─── Inbox ───
  'inbox.title': 'Inbox',
  'inbox.pickConversation': 'Pick a conversation to reply.',
  'inbox.errorOpen': 'Could not open the conversation.',
  'inbox.errorConnections': 'Could not load the connections.',
  'inbox.errorConversations': 'Could not load the conversations.',

  // --- Dashboard / WhatsApp / Historico / Usuarios ---
  'dash.title': 'Dashboard',
  'dash.overview': 'System overview',
  'dash.recent': 'Recent Messages',
  'dash.byStatus': 'By Status',
  'dash.deliveryRates': 'Delivery Rates',
  'dash.seeAll': 'See all',
  'dash.noMessages': 'No messages sent yet.',
  'dash.sendFirst': 'Send your first message in "WhatsApp".',
  'wa.title': 'WhatsApp Template Sending',
  'wa.subtitle': 'Send messages using Meta-approved templates',
  'wa.subtitleShort': 'Send Meta pre-approved templates.',
  'wa.send': 'Send Message',
  'wa.refresh': 'Refresh',
  'wa.clear': 'Clear',
  'wa.logs': 'Sending Logs',
  'wa.sender': 'Sender',
  'wa.recipientPhone': 'Recipient Phone',
  'wa.template': 'Meta Template',
  'wa.pickTemplate': 'Select an approved template...',
  'wa.pick': 'Select...',
  'hist.title': 'Sending History',
  'hist.date': 'Date',
  'hist.recipient': 'Recipient',
  'hist.status': 'Status',
  'hist.template': 'Template',
  'hist.messageId': 'Message ID',
  'hist.empty': 'No messages sent',
  'hist.emptyHint': 'Send messages in "WhatsApp" to see the history here.',
  'users.title': 'Manage Users',
  'users.subtitle': 'Manage the system users',
  'users.new': 'New User',
  'users.name': 'Name',
  'users.fullName': 'Full name',
  'users.email': 'Email',
  'users.password': 'Password',
  'users.role': 'Role',
  'users.actions': 'Actions',
  'users.status': 'Status',
  'users.admin': 'Administrator',
  'users.operator': 'Operator',
  'users.user': 'User',
  'users.empty': 'No users found',
  'users.emailPlaceholder': 'email@example.com',

  // --- Templates / Conexoes / Configuracoes ---
  'tpl.title': 'WhatsApp Templates',
  'tpl.subtitle': 'Manage your Meta message templates',
  'tpl.new': 'New Template',
  'tpl.create': 'Create New Template',
  'tpl.existing': 'Existing Templates',
  'tpl.loading': 'Loading templates...',
  'tpl.empty': 'No templates found.',
  'tpl.emptyHint': 'Create your first template by clicking "New Template"',
  'tpl.nameHint': 'Lowercase letters, numbers and underscores only',
  'tpl.namePlaceholder': 'e.g. customer_welcome',
  'tpl.delete': 'Delete template',
  'tpl.warning': 'Warning:',
  'tpl.irreversible': 'This action cannot be undone',
  'tpl.removedFromMeta': 'The template will be removed from Meta/WhatsApp',
  'tpl.nameLocked': 'The name cannot be reused for 30 days',
  'tpl.maxButtons': 'Maximum of 3 buttons',
  'tpl.quickReply': 'Quick Reply',
  'tpl.noButtons': 'No buttons',
  'tpl.noHeader': 'No header',
  'tpl.text': 'Text',
  'tpl.headerText': 'Header text',
  'tpl.footerText': 'Footer text (optional)',
  'tpl.bodyExample': 'Hi {{1}}, welcome! Your order {{2}} has been confirmed.',
  'conn.title': 'Meta API Connections',
  'conn.waTitle': 'WhatsApp Business API',
  'conn.new': 'New Connection',
  'conn.name': 'Connection Name',
  'conn.empty': 'No connection configured',
  'conn.delete': 'Delete Connection',
  'conn.deleting': 'Deleting...',
  'conn.saving': 'Saving...',
  'conn.saveChanges': 'Save Changes',
  'conn.accessToken': 'Access Token',
  'conn.accessTokenRequired': 'Access Token *',
  'conn.phoneNumberId': 'Phone Number ID *',
  'conn.wabaId': 'WABA ID',
  'conn.idExample': 'e.g. 123456789012345',
  'set.title': 'Settings',
  'set.saved': 'Settings saved successfully!',
  'set.company': 'Company Information',
  'set.profile': 'User Profile',
  'set.social': 'Social Networks',
  'set.dpo': 'LGPD - Data Protection Officer (DPO)',
  'set.footerPreview': 'Footer Preview',
  'set.dangerZone': 'Danger Zone',
  'set.fullName': 'Full name',
  'set.descPlaceholder': 'Short company description...',
  'set.addressPlaceholder': 'Street, number, complement',
  'set.emailPlaceholder': 'contact@company.com',
  'set.dpoEmailPlaceholder': 'dpo@company.com',

  // --- Paginas publicas / exclusao de dados ---
  'land.officialApi': 'Official Meta API',
  'land.features': 'Features',
  'land.featuresUpper': 'FEATURES',
  'land.links': 'Links',
  'land.about': 'About',
  'land.contact': 'Contact',
  'land.address': 'Address',
  'about.companyInfo': 'Company Information',
  'about.ourStory': 'Our Story',
  'about.ourValues': 'Our Values',
  'about.ourTeam': 'Our Team',
  'about.legalName': 'Legal Name',
  'about.cnpj': 'CNPJ',
  'about.email': 'E-mail',
  'about.phone': 'Phone',
  'about.website': 'Website',
  'about.addr': 'Address',
  'about.companiesServed': 'Companies served',
  'about.messagesSent': 'Messages sent',
  'about.uptime': 'Guaranteed uptime',
  'contact.title': 'Get in Touch',
  'contact.sendYours': 'Send your Message',
  'contact.send': 'Send Message',
  'contact.sending': 'Sending...',
  'contact.sent': 'Message Sent!',
  'contact.companyData': 'Company Details',
  'contact.legalName': 'Legal Name:',
  'contact.cnpjLabel': 'CNPJ:',
  'contact.yourName': 'Your name',
  'contact.describe': 'Describe how we can help...',
  'contact.pick': 'Select...',
  'contact.sales': 'Sales',
  'contact.support': 'Technical Support',
  'contact.finance': 'Finance',
  'contact.partnerships': 'Partnerships',
  'contact.other': 'Other Subject',
  'contact.hours': 'Monday to Friday, 8am to 6pm',
  'contact.addr': 'Address',
  'contact.phone': 'Phone',
  'contact.emailLabel': 'E-mail',
  'contact.emailPlaceholder': 'you@email.com',
  'del.title': 'Data Deletion',
  'del.request': 'Request Deletion of My Data',
  'del.confirmButton': 'DELETE MY DATA',
  'del.processing': 'Processing...',
  'del.currentPassword': 'Your current password',
  'del.personalData': 'Your personal data (name, email, phone)',
  'del.messageHistory': 'History of sent messages',
  'del.apiConnections': 'All WhatsApp API connections',
  'del.settings': 'Settings and preferences',
  'del.metaStored': 'Data stored in the Meta/WhatsApp Business API',
  'delreq.whatIsDeleted': 'Data that will be deleted',
  'delreq.profileInfo': 'Profile information (name, email, phone)',
  'delreq.waConnections': 'WhatsApp Business API connections',
  'delreq.sendRequest': 'Send your request',
  'delreq.identityCheck': 'Identity verification',
  'delreq.processing': 'Processing',
  'delreq.confirmation': 'Confirmation',
  'delreq.why': 'Tell us why you want to delete your data...',
  'delreq.backHome': 'Back to home',

  // --- Juridico: SO os titulos de secao estao traduzidos.
  // O corpo das clausulas continua em portugues de proposito: traducao
  // nao revisada de texto legal pode divergir do original e ser usada
  // contra a empresa. legal.notice avisa isso ao leitor em ingles.
  'legal.notice': 'This document is provided in Portuguese. The Portuguese version is the authoritative text and prevails in case of any discrepancy.',
  'pp.1': '1. Introduction',
  'pp.2': '2. Information We Collect',
  'pp.3': '3. How We Use Your Information',
  'pp.4': '4. Data Sharing',
  'pp.5': '5. Cookies',
  'pp.6': '6. Data Security',
  'pp.7': '7. Your Rights (LGPD)',
  'pp.8': '8. Data Retention',
  'pp.9': '9. Contact',
  'pp.10': '10. Changes to this Policy',
  'tou.1': '1. Acceptance of Terms',
  'tou.2': '2. Service Description',
  'tou.3': '3. Registration and Account',
  'tou.4': '4. Acceptable Use',
  'tou.5': '5. Intellectual Property',
  'tou.6': '6. Payment and Subscription',
  'tou.7': '7. Limitation of Liability',
  'tou.8': '8. Service Availability',
  'tou.9': '9. Suspension and Termination',
  'tou.10': '10. Changes to the Terms',
  'tou.11': '11. Governing Law',
  'tou.12': '12. Contact',

  // --- Componentes: cookies e painel de logs ---
  'cookie.title': 'This site uses cookies',
  'cookie.body': 'We use cookies to improve your browsing experience, personalize content and ads, provide social media features and analyze our traffic. By clicking "Accept all", you agree to the use of all cookies. You can manage your preferences by clicking "Essential only".',
  'cookie.acceptAll': 'Accept all',
  'cookie.essentialOnly': 'Essential only',
  'cookie.privacyPolicy': 'Privacy Policy',
  'cookie.essential': 'Essential:',
  'cookie.essentialDesc': 'Required for the site to work',
  'cookie.analytics': 'Analytics:',
  'cookie.analyticsDesc': 'Help us improve the site',
  'cookie.marketing': 'Marketing:',
  'cookie.marketingDesc': 'Personalize ads',
  'log.title': 'Logs',
  'log.entryOne': 'entry',
  'log.entryMany': 'entries',

  // --- Titulos das paginas juridicas ---
  'pp.title': 'Privacy Policy',
  'tou.title': 'Terms of Use',

  // --- Secao de idioma em Configuracoes ---
  'set.language': 'Language',
  'set.languageHint': 'Applies to the whole panel and is saved in this browser.',

  // --- Lacunas encontradas na auditoria de cobertura ---
  'dash.overviewFull': 'System overview',
  'hist.refresh': 'Refresh',
  'users.loading': 'Loading...',
  'users.confirmDelete': 'Are you sure you want to delete this user?',
  'users.errDelete': 'Error deleting user',
  'users.errStatus': 'Error updating status',
  'set.errLoad': 'Error loading settings',
  'set.errSave': 'Error saving settings',
  'set.websitePlaceholder': 'https://www.company.com',
  'set.instagramPlaceholder': 'https://instagram.com/company',
  'set.facebookPlaceholder': 'https://facebook.com/company',
  'set.linkedinPlaceholder': 'https://linkedin.com/company/company',
  'del.typePassword': 'Type your password to confirm',
  'delreq.emailMismatch': 'The emails do not match.',
  'tpl.noActiveConnection': 'No active connection found. Set up a connection in "Connections" to create templates.',
  'meta.igsidHint': 'Enter the @username (e.g. @pressadigital) or the IGSID. Only works for people who messaged you in the last 24h.',

  // --- Tela de conexoes Meta (lote 1: literais simples) ---
  'mc.cancel': 'Cancel',
  'mc.loadingComments': 'Loading comments...',
  'mc.loadingChats': 'Loading conversations...',
  'mc.loadComments': 'Load comments',
  'mc.loadChats': 'Load conversations',
  'mc.connected': 'Connected',
  'mc.connect': 'Connect',
  'mc.disconnected': 'Disconnected',
  'mc.pending': 'Pending',
  'mc.created': 'Connection created!',
  'mc.copied': 'Copied',
  'mc.copy': 'Copy',
  'mc.createConnection': 'Create Connection',
  'mc.createFirst': 'Create first connection',
  'mc.newConnection': 'New Connection',
  'mc.sending': 'Sending...',
  'mc.send': 'Send',
  'mc.sendMessage': 'Send message',
  'mc.error': 'Error',
  'mc.writeReply': 'Write your reply',
  'mc.deleting': 'Deleting...',
  'mc.delete': 'Delete',
  'mc.noChanges': 'No changes',
  'mc.personName': 'Person name (e.g. Sostenes)',
  'mc.fillRecipient': 'Fill in the recipient (IGSID) and the message',
  'mc.reply': 'Reply',
  'mc.saved': 'Saved successfully!',
  'mc.testing': 'Testing...',
  'mc.test': 'Test',
  'mc.callbackUrl': 'Callback URL (Webhook)',
  'mc.urlGenerated': 'URL generated! Redirecting to Facebook Login...',
  'mc.statusConnected': 'STATUS: CONNECTED!',
  'mc.loading': 'Loading...',
  'mc.hintAfterCreate': 'After creating, click "Connect" to authorize via Facebook Login. Set up the webhook in Facebook Developers.',
  'mc.hintIgLogin': 'Register under Instagram > API setup with Instagram login > Business login settings.',
  'mc.hintIgWebhook': 'Register under Instagram > API setup with Instagram login > Webhooks. Fields: messages, comments.',
  'mc.hintFbRedirect': 'Register under Facebook Login > Settings > Valid OAuth redirect URIs.',
  'mc.hintFbWebhook': 'Register under Webhooks > Page. Fields: messages, messaging_postbacks.',

  // --- convertidas automaticamente (lote auto) ---
  'connection.a1': 'Loading saved connections...',
  'connection.a2': 'Checking status with the Meta API...',
  'connection.a3': 'Total: {{v1}} Meta connection(s)',
  'connection.a4': 'Connection: "{{v1}}"',
  'connection.a5': 'Status: CONNECTED',
  'connection.a6': 'Verified Name: {{v1}}',
  'connection.a7': 'Status: DISCONNECTED',
  'connection.a8': 'ERROR loading connections',
  'connection.a9': 'Message: {{v1}}',
  'connection.a10': 'Error reloading connections',
  'connection.a11': 'Connection: "{{v1}}"',
  'connection.a12': 'Sending request to the Meta API...',
  'connection.a13': 'REQUEST PAYLOAD (sent to Meta):',
  'connection.a14': 'STATUS: CONNECTION ACTIVE!',
  'connection.a15': 'Verified Name: {{v1}}',
  'connection.a16': 'RESPONSE PAYLOAD (returned by Meta):',
  'connection.a17': 'STATUS: CONNECTION FAILED',
  'connection.a18': 'Error: {{v1}}',
  'connection.a19': 'ERROR PAYLOAD (returned by Meta):',
  'connection.a20': 'STATUS: REQUEST ERROR',
  'connection.a21': 'Message: {{v1}}',
  'connection.a22': 'No changes to save',
  'connection.a23': 'Connection: "{{v1}}"',
  'connection.a24': 'Access Token: {{v1}}... (NEW)',
  'connection.a25': 'Sending update...',
  'connection.a26': '[TOKEN HIDDEN]',
  'connection.a27': 'STATUS: CONNECTION UPDATED!',
  'connection.a28': 'Meta API: token validated successfully!',
  'connection.a29': 'Meta API: token saved but the connection failed',
  'connection.a30': 'Connection updated successfully!',
  'connection.a31': 'Error saving connection',
  'connection.a32': 'STATUS: UPDATE FAILED',
  'connection.a33': 'Error: {{v1}}',
  'connection.a34': 'Are you sure you want to delete the connection "{{v1}}"?\\n\\nThis action cannot be undone.',
  'connection.a35': 'Deleting connection "{{v1}}"...',
  'connection.a36': 'Connection "{{v1}}" deleted successfully!',
  'connection.a37': 'Error deleting connection',
  'connection.a38': 'Error deleting: {{v1}}',
  'connection.a39': 'Name: "{{v1}}"',
  'connection.a40': 'Access Token: {{v1}}...',
  'connection.a41': 'Sending data to create the connection...',
  'connection.a42': 'REQUEST PAYLOAD (sent to Meta):',
  'connection.a43': 'STATUS: CONNECTION CREATED SUCCESSFULLY!',
  'connection.a44': 'Meta API: connection verified and active!',
  'connection.a45': 'RESPONSE PAYLOAD (returned by Meta):',
  'connection.a46': 'Meta API: connection created but not verified',
  'connection.a47': 'ERROR PAYLOAD (returned by Meta):',
  'connection.a48': 'Error creating connection',
  'connection.a49': 'STATUS: FAILED TO CREATE CONNECTION',
  'connection.a50': 'Error: {{v1}}',
  'connection.a51': 'Connected',
  'connection.a52': 'Disconnected',
  'connection.a53': 'Current token: {{v1}}... (paste a new token to replace it)',
  'connection.a54': 'Paste the Meta Access Token here',
  'connection.a55': 'Testing...',
  'connection.a56': 'Test Connection',

  // --- convertidas automaticamente (lote auto) ---
  'about.a1': 'We constantly look for new ways to improve communication between companies and their customers.',
  'about.a2': 'We build intuitive solutions that make our users\' day-to-day easier.',
  'about.a3': 'We put the security and privacy of our customers\' data first.',
  'about.a4': 'A commitment to quality in everything we do.',
  'dashboardh.a1': 'Error loading stats:',
  'dashboardh.a2': 'Messages Today',
  'dashboardh.a3': '{{v1}} this week',
  'dashboardh.a4': 'Total Messages',
  'dashboardh.a5': '{{v1}} this month',
  'dashboardh.a6': 'Active Connections',
  'dashboardh.a7': 'Active Users',
  'dashboardh.a8': 'Failed',
  'datadeleti.a1': 'DELETE MY DATA',
  'datadeleti.a2': 'Type exactly "DELETE MY DATA" to confirm',
  'datadeleti.a3': 'Error processing request',
  'datadeleti.a4': 'DELETE MY DATA',
  'history.a1': 'Error loading history:',
  'landingpag.a1': 'Unified Inbox',
  'landingpag.a2': 'Manage every WhatsApp conversation in one place, without switching devices.',
  'landingpag.a3': 'Lead Pipeline (Kanban)',
  'landingpag.a4': 'See your opportunities in a sales funnel: New, In Progress, Negotiating and Closed.',
  'landingpag.a5': 'Tag System',
  'landingpag.a6': 'Organize contacts with custom labels to segment and filter them quickly.',
  'landingpag.a7': 'Product Catalog',
  'landingpag.a8': 'Manage and send product offers straight from the chat with your integrated catalog.',
  'landingpag.a9': 'A complete conversation management platform built on the WhatsApp Business API. Centralize your messages',
  'metaconnec.a1': 'Sending Direct to {{v1}}: "{{v2}}"',
  'metaconnec.a2': 'Message sent! {{v1}}',
  'metaconnec.a3': 'Send failed: {{v1}}',
  'metaconnec.a4': 'Loading comments...',
  'metaconnec.a5': '{{v1}} comment(s) loaded',
  'metaconnec.a6': 'Error loading comments: {{v1}}',
  'metaconnec.a7': 'Replying to @{{v1}}: "{{v2}}"',
  'metaconnec.a8': 'Reply sent to @{{v1}}!',
  'metaconnec.a9': 'Reply failed: {{v1}}',
  'metaconnec.a10': '{{v1}} conversation(s) loaded',
  'metaconnec.a11': 'Error loading conversations: {{v1}}',
  'metaconnec.a12': 'Reply sent to {{v1}}!',
  'metaconnec.a13': 'Reply failed: {{v1}}',
  'metaconnec.a14': '{{v1}} connected successfully!',
  'metaconnec.a15': 'Connection error: {{v1}}',
  'metaconnec.a16': 'Total: {{v1}} Meta connection(s)',
  'metaconnec.a17': 'Connection: "{{v1}}" ({{v2}})',
  'metaconnec.a18': 'Page: {{v1}}',
  'metaconnec.a19': 'Status: {{v1}}',
  'metaconnec.a20': 'Error loading: {{v1}}',
  'metaconnec.a21': 'Page: {{v1}}',
  'metaconnec.a22': 'STATUS: {{v1}}',
  'metaconnec.a23': 'Error: {{v1}}',
  'metaconnec.a24': 'Test error: {{v1}}',
  'metaconnec.a25': 'Generating authorization URL for "{{v1}}"...',
  'metaconnec.a26': 'Error generating URL: {{v1}}',
  'metaconnec.a27': 'Connection "{{v1}}" updated!',
  'metaconnec.a28': 'Error saving: {{v1}}',
  'metaconnec.a29': 'Delete connection "{{v1}}"?\\nThis action cannot be undone.',
  'metaconnec.a30': 'Connection "{{v1}}" deleted',
  'metaconnec.a31': 'Error deleting: {{v1}}',
  'metaconnec.a32': 'Creating connection "{{v1}}"...',
  'metaconnec.a33': 'Verify Token: {{v1}}',
  'metaconnec.a34': 'Error creating: {{v1}}',
  'metaconnec.a35': 'Register under Instagram > API setup with Instagram login > Business login settings. It must match character for character.',
  'metainbox.a1': '{{v1}}/meta-connections/{{v2}}/stream?token={{v3}}',
  'metainbox.a2': 'Could not send the reply.',
  'metainbox.a3': 'Live',
  'metainbox.a4': 'Reconnecting',
  'metainbox.a5': 'Comment',
  'metainbox.a6': 'Message',
  'metainbox.a7': 'Post comments',
  'metainbox.a8': 'Conversation',
  'metainbox.a9': 'You',
  'metainbox.a10': 'Reply to the comment...',
  'metainbox.a11': 'Write your reply...',
  'metainbox.a12': 'Sending...',
  'metainbox.a13': 'Reply',
  'settings.a1': 'Error loading settings:',
  'settings.a2': 'Error saving:',
  'settings.a3': 'Saving...',
  'settings.a4': 'Save Settings',
  'settings.a5': 'admin@chatflow.com',
  'settings.a6': 'Company Name',
  'templates.a1': 'Loading templates and connections...',
  'templates.a2': '{{v1}} active connections',
  'templates.a3': 'Error loading data',
  'templates.a4': 'Name: "{{v1}}"',
  'templates.a5': 'Language: {{v1}}',
  'templates.a6': 'Sending to the Meta API...',
  'templates.a7': 'REQUEST PAYLOAD (sent to Meta):',
  'templates.a8': 'STATUS: TEMPLATE CREATED!',
  'templates.a9': 'Status: {{v1}}',
  'templates.a10': 'RESPONSE PAYLOAD (returned by Meta):',
  'templates.a11': 'Template created successfully! Status: {{v1}}',
  'templates.a12': 'Error creating template',
  'templates.a13': 'REQUEST PAYLOAD (sent to Meta):',
  'templates.a14': 'STATUS: CREATION FAILED',
  'templates.a15': 'Error: {{v1}}',
  'templates.a16': 'ERROR PAYLOAD (returned by Meta):',
  'templates.a17': 'Pending',
  'templates.a18': 'Name: "{{v1}}"',
  'templates.a19': 'Sending DELETE request to the Meta API...',
  'templates.a20': 'STATUS: TEMPLATE DELETED!',
  'templates.a21': 'Template "{{v1}}" deleted successfully!',
  'templates.a22': 'Error deleting template',
  'templates.a23': 'STATUS: DELETION FAILED',
  'templates.a24': 'Error: {{v1}}',
  'templates.a25': 'ERROR PAYLOAD (returned by Meta):',
  'users.a1': 'Error creating user',
  'users.a2': 'Active',
  'users.a3': 'Inactive',
  'whatsapp.a1': 'Loading templates and connections...',
  'whatsapp.a2': 'Error loading data',
  'whatsapp.a3': 'Connection:',
  'whatsapp.a4': 'MESSAGE SENT! ID:',
  'whatsapp.a5': 'Message sent! ID:',
  'whatsapp.a6': 'Error sending',
  'whatsapp.a7': 'FAILED:',
  'whatsapp.a8': 'Sending...',
  'whatsapp.a9': 'Send Message',

  // --- texto JSX convertido automaticamente ---
  'about.j1': 'Back to home',
  'about.j2': 'Transforming how companies talk to their customers through intelligent solutions.',
  'about.j3': 'Our team, made up of technology and communication specialists, built a complete platform for managing conversations.',
  'about.j4': 'Today we serve hundreds of companies across Brazil, from small businesses to large operations.',
  'about.j5': 'We keep evolving the platform with new features, always listening to our customers\' feedback.',
  'about.j6': 'We have a multidisciplinary team of developers, designers and support specialists.',
  'connection.j1': 'New Connection',
  'connection.j2': 'Create first connection',
  'connection.j3': 'Permanent access token for the WhatsApp Business API. Leave blank to keep the current one.',
  'connection.j4': 'WhatsApp Business account ID (found in the Meta Business panel).',
  'connection.j5': 'API Logs',
  'connection.j6': 'No logs available.',
  'connection.j7': 'Perform an action to see the logs.',
  'connection.j8': 'Cancel',
  'connection.j9': 'Create Connection',
  'contact.j1': 'Back to home',
  'contact.j2': 'We are ready to help. Send your message and we will reply shortly.',
  'contact.j3': 'contato@chatflow.com.br',
  'contact.j4': 'suporte@chatflow.com.br',
  'contact.j5': 'Thank you for reaching out. Our team will reply within 24 business hours.',
  'contact.j6': 'Send Another Message',
  'contact.j7': 'Full Name *',
  'contact.j8': 'Message *',
  'contact.j9': 'Privacy Policy',
  'datadeleti.j1': 'Data Deletion Request',
  'datadeleti.j2': 'In accordance with the Brazilian General Data Protection Law (LGPD) and Meta policies, you can request the deletion of your personal data.',
  'datadeleti.j3': 'We received your data deletion request. You will get a confirmation email within 48 hours.',
  'datadeleti.j4': 'Back to home',
  'datadeleti.j5': 'How data deletion works',
  'datadeleti.j6': 'Fill in the form below with the email linked to your account.',
  'datadeleti.j7': 'We will send a confirmation email to verify your identity.',
  'datadeleti.j8': 'Your data will be deleted within 30 days, as required by the LGPD.',
  'datadeleti.j9': 'You will receive an email confirming the complete deletion of your data.',
  'datadeleti.j10': 'Request Form',
  'datadeleti.j1': 'Data Deletion Request',
  'datadeleti.j2': 'In accordance with the Brazilian General Data Protection Law (LGPD) and Meta policies, you can request the deletion of your personal data.',
  'datadeleti.j3': 'We received your data deletion request. You will get a confirmation email within 48 hours.',
  'datadeleti.j4': 'Back to home',
  'datadeleti.j5': 'How data deletion works',
  'datadeleti.j6': 'Fill in the form below with the email linked to your account.',
  'datadeleti.j7': 'We will send a confirmation email to verify your identity.',
  'datadeleti.j8': 'Your data will be deleted within 30 days, as required by the LGPD.',
  'datadeleti.j9': 'You will receive an email confirming the complete deletion of your data.',
  'datadeleti.j10': 'Request Form',
  'datadeleti.j11': 'Account email *',
  'datadeleti.j12': 'Confirm your email *',
  'datadeleti.j13': 'Reason for the request (optional)',
  'datadeleti.j14': 'Already have an account?',
  'datadeleti.j15': 'Questions about data deletion?',
  'datadeleti.j16': 'Get in touch:',
  'datadeleti.j17': 'Set the contact email in the system settings.',
  'datadeleti.j18': 'Privacy Policy',
  'datadeleti.j19': 'Terms of Use',
  'landingpag.j1': 'Smart Management of',
  'landingpag.j2': 'WhatsApp Conversations',
  'landingpag.j3': 'Centralize conversations, organize leads and send approved templates straight from your dashboard.',
  'landingpag.j4': 'Get Started',
  'landingpag.j5': 'See a Demo',
  'landingpag.j6': 'Everything you need to',
  'landingpag.j7': 'manage your sales',
  'landingpag.j8': 'Ready to transform',
  'landingpag.j9': 'your WhatsApp sales?',
  'landingpag.j10': 'Start now and see results in minutes.',
  'landingpag.j11': 'Access Free Demo',
  'landingpag.j12': 'About Us',
  'landingpag.j13': 'Privacy Policy',
  'landingpag.j14': 'Terms of Use',
  'landingpag.j15': 'Data Deletion',
  'landingpag.j16': 'Terms',
  'landingpag.j17': 'Support',
  'metaconnec.j1': 'After creating, click Connect to authorize via Facebook Login. Set up the webhook in Facebook Developers with the URL and Verify Token provided.',
  'metainbox.j1': 'No Instagram or Facebook connection registered. Create the connection in',
  'metainbox.j2': 'and connect the account to start receiving messages.',
  'metainbox.j3': 'No messages yet. Send a DM to the connected account â€” it shows up here on its own, no refresh needed.',
  'settings.j1': 'Company Name *',
  'settings.j2': 'Company Description',
  'settings.j3': 'Details of the person responsible for personal data protection under the LGPD.',
  'settings.j4': 'DPO Name',
  'settings.j5': 'DPO Email',
  'settings.j6': 'Export Data',
  'settings.j7': 'Delete Account',
  'templates.j1': 'Template Logs',
  'templates.j2': 'No logs available.',
  'templates.j3': 'Create a template to see the logs.',
  'templates.j4': 'Template Name *',
  'templates.j5': 'Language *',
  'templates.j6': 'Message Body *',
  'templates.j7': 'Add Button',
  'templates.j8': 'Cancel',
  'templates.j9': 'Cancel',
  'users.j1': 'Cancel',
  'users.j2': 'Create User',
  'logpanel.j1': 'No logs available.',

  // --- separadores de log e restos ---
  'log.sepUpdateConn': '========== UPDATE CONNECTION ==========',
  'log.sepLoadConns': '========== LOADING CONNECTIONS ==========',
  'log.sepNewConn': '========== CREATE NEW CONNECTION ==========',
  'log.sepTestConn': '========== CONNECTION TEST ==========',
  'log.sepLoadMeta': '========== LOADING META CONNECTIONS ==========',
  'log.sepSendTemplate': '========== TEMPLATE SENDING ==========',
  'log.unknownError': 'Unknown error',
  'log.notConfigured': 'Not configured',
  'log.notProvided': 'Not provided',
  'mc.appOkPageNot': 'APP OK, PAGE NOT CONNECTED',
  'mc.errorUpper': 'ERROR',
  'auth.loginError': 'Login failed',
  'set.loadError': 'Error loading settings:',
  'tpl.varsHint': 'for dynamic variables',
  'hist.pageOf': 'Page of',
  'hist.messagesTotal': 'messages total',

  // --- paragrafos com interpolacao ---
  'about.story1': '{{v1}} was born to simplify business communication through the WhatsApp Business API. We saw that many companies struggled to manage conversations at scale, organize leads and keep up a quality service.',
  'delreq.haveAccount': 'If you already have a {{v1}} account, you can request deletion directly from the panel, under Menu > Data Deletion. That route is faster and needs no extra verification.',
  'contact.consent': 'By submitting this form, you agree to our',

  // --- ultimos restos com interpolacao ---
  'inbox.idLabel': ' · ID {{v1}}',
  'inbox.chatsCount': 'Conversations ({{v1}})',
  'log.sepTesting': '========== TESTING "{{v1}}" ==========',
  'hist.totalMessages': '{{v1}} messages total',
  'tpl.varsHintFull': 'Use {{1}}, {{2}}, etc for dynamic variables',

  // --- reconectar e codigos de erro do OAuth ---
  'mc.connectPlatform': 'Connect {{v1}}',
  'mc.reconnectPlatform': 'Reconnect {{v1}}',
  'mc.reconnectHint': 'Reconnect once so the token picks up the new permissions (publishing and insights).',
  'err.login_cancelled': 'Login cancelled',
  'err.missing_params': 'Missing parameters in the Meta response',
  'err.connection_not_found': 'Connection not found',
  'err.no_pages': 'No Facebook Page available on this account',
  'err.missing_code': 'Meta did not return the authorization code',
  'err.state_invalido_ou_expirado': 'Authorization session expired, please try again',

  // --- Human Agent (doc 13, secao 4) ---
  'ha.label': 'Send as human agent',
  'ha.hint': 'Use only for a reply typed by a person, outside the 24h window (valid up to 7 days). Meta forbids it on automated messages.',

  // --- restos do envio de Direct ---
  'mc.noText': '(no text)',
  'mc.igsidOrUser': '@username (IG) or IGSID',

  // --- telas Publish e Insights (docs 12 e 13) ---
  'nav.publish': 'Publish',
  'nav.insights': 'Insights',
  'pub.title': 'Publish',
  'pub.pickConn': 'Connection',
  'pub.noConn': 'No connected account. Connect one under Meta.',
  'pub.fbPost': 'Publish to the Page',
  'pub.fbMessage': 'Post text',
  'pub.fbLink': 'Link (optional)',
  'pub.fbPhoto': 'Image URL (optional)',
  'pub.fbCaption': 'Image caption',
  'pub.publish': 'Publish',
  'pub.publishing': 'Publishing...',
  'pub.published': 'Published!',
  'pub.viewOnFb': 'View post on Facebook',
  'pub.viewOnIg': 'View post on Instagram',
  'pub.posts': 'Page posts',
  'pub.loadPosts': 'Load posts',
  'pub.noPosts': 'No posts loaded.',
  'pub.comments': '{{v1}} comment(s)',
  'pub.hide': 'Hide',
  'pub.unhide': 'Unhide',
  'pub.deleteCm': 'Delete',
  'pub.confirmDel': 'Delete this comment? This cannot be undone.',
  'pub.igTitle': 'Publish to Instagram',
  'pub.igType': 'Type',
  'pub.igPhoto': 'Photo',
  'pub.igCarousel': 'Carousel',
  'pub.igReels': 'Reels',
  'pub.igImageUrl': 'Public image URL (JPG)',
  'pub.igVideoUrl': 'Public video URL',
  'pub.igImages': 'Image URLs, one per line (2 to 10)',
  'pub.igCaption': 'Caption',
  'pub.step1': 'Creating container...',
  'pub.step2': 'Processing at Meta ({{v1}}s)...',
  'pub.step3': 'Publishing...',
  'pub.timeout': 'Meta did not finish processing in time. Try publishing again shortly.',
  'pub.mediaError': 'Meta rejected the media: {{v1}}',
  'ins.title': 'Insights',
  'ins.account': 'Account',
  'ins.followers': 'Followers',
  'ins.follows': 'Following',
  'ins.mediaCount': 'Posts',
  'ins.reach': 'Reach',
  'ins.views': 'Views',
  'ins.engaged': 'Accounts engaged',
  'ins.interactions': 'Interactions',
  'ins.profileViews': 'Profile views',
  'ins.last28': 'Last {{v1}} days',
  'ins.byPost': 'Performance by post',
  'ins.post': 'Post',
  'ins.likes': 'Likes',
  'ins.saved': 'Saved',
  'ins.load': 'Load insights',
  'ins.empty': 'No insights loaded.',
  'ins.onlyIg': 'Insights are available for Instagram accounts.'
};

export default en;
